import { language, textHandler } from './index'
import se from './strings/common/se.json'
import fi from './strings/common/fi.json'
import dk from './strings/common/dk.json'
import no from './strings/common/no.json'

let commonStrings = null
let strings = null

const loadCommon = async language => {
  commonStrings = await import(`./strings/common/${language}`)
}

export default (...args) => {
  if (strings === null)
    strings = { se, fi, dk, no }[language]
  return textHandler.getText(strings, args)
}

export { commonStrings, loadCommon }